<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2023-05-06 09:12:45
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-13 09:31:25
 * @FilePath: \plantingSubsidy_web_update\src\views\statistics-charts\insurance-statistics\InsurancePolicy.vue
 * @Description: 承保一张图-查询保单

-->
<template>
  <a-card :bordered="false"
          class="card-area">
    <a-form layout="horizontal">
      <a-row>
        <a-col :md="4"
               :sm="24">
          <a-button type="primary"
                    ghost
                    class="u_btn u_btn_radius u_btn1"
                    @click="handleBack">返回</a-button>
        </a-col>

      </a-row>
      <a-row>
        <a-col :md="4"
               :sm="24">
          <a-form-item label="投保年度"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <a-select placeholder="请选择"
                      v-model="queryParams.year"
                      @change="handleChangeYear">
              <a-select-option v-for="r in yearList"
                               :key="r.year"
                               :value="r.year">{{ r.year }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="4"
               :sm="24">
          <a-form-item label="承保机构"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <a-select placeholder="请选择"
                      v-model="queryParams.companyId">
              <a-select-option v-for="r in orgList"
                               :key="r.deptId"
                               :value="r.deptId">{{ r.deptName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="8"
               :sm="24">
          <a-form-item label="地区"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <!-- <a-select placeholder="省|市|县|乡|村"
                      v-model="queryParams.organ">
              <a-select-option v-for="r in organList"
                               :key="r.id"
                               :value="r.id">{{ r.name }}</a-select-option>
            </a-select> -->
            <a-cascader v-model="queryParams.address"
            :options="options"
                        :load-data="loadData"
                        placeholder="省 | 市 | 县 | 乡 | 村"
                        change-on-select
                        @change="onChange"
                        :allowClear="false" />

          </a-form-item>
        </a-col>
        <a-col :md="4"
               :sm="24">
          <a-form-item label="保单号"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">

            <a-input placeholder="请输入"
                     v-model="queryParams.policyNo" />

          </a-form-item>
        </a-col>
        <a-col :md="4"
               :sm="24">
          <a-form-item label="保单类型"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <a-select placeholder="请选择"
                      v-model="queryParams.policyType">
              <a-select-option v-for="r in orderList"
                               :key="r.id"
                               :value="r.id">{{ r.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="4"
               :sm="24">
          <a-form-item label="投保险种"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <a-select placeholder="请选择"
                      v-model="queryParams.insuranceType">
              <a-select-option v-for="r in typeList"
                               :key="r.id"
                               :value="r.standardsId">{{ r.typeName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="4"
               :sm="24">
          <a-form-item label="保单状态"
                       :labelCol="{ span: 6 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <a-select placeholder="请选择"
                      v-model="queryParams.policyStatus">
              <a-select-option v-for="r in orderStatusList"
                               :key="r.id"
                               :value="r.id">{{ r.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6"
               :sm="24">
          <div style="padding-top:4px;">
            <a-button type="primary"
                      ghost
                      class="u_btn u_btn1"
                      @click="handleSearch">查询</a-button>
            <a-button type="primary"
                      ghost
                      class="u_btn u_btn2"
                      @click="handleExport">导出数据</a-button>
            <a-button type="primary"
                      ghost
                      class="u_btn u_btn3"
                      @click="handleReset">重置</a-button>
          </div>

        </a-col>
      </a-row>
    </a-form>
    <!-- 表格区域 -->
    <a-table ref="TableInfo" style="height:80%"
             size="small"
             :rowKey="record => record.slipCode"
             :columns="columns"
             :dataSource="dataSource"
             :pagination="pagination"
             :loading="loading"
             :scroll="{ x: 1600,y:560}"
             bordered
             @change="handleTableChange">
      <template slot="operation"
                slot-scope="text, record">
        <div class="opt_box">
          <a href="javascript:;"
             @click.prevent="handleInsurancePerson(record)">投保人名单</a>

        </div>
      </template>
    </a-table>
    <!-- 投保人名单 -->
    <insurance-person ref="insurancePersonPage"
                      :visible="insurancePersonVisible"
                      @close="handleInsurancePersonClose"
                      @lot="handleLotDetail" />
    <!-- 投保地块 -->
    <insurance-lot ref="insuranceLotPage"
                   :visible="insuranceLotVisible"
                   @close="handleInsuranceLotClose" />
  </a-card>

</template>
<script>
import InsurancePerson from './InsurancePerson.vue'
import InsuranceLot from './InsuranceLot.vue'
export default {
  components: { InsurancePerson, InsuranceLot },
  data () {
    return {
      level: this.$store.state.account.user.level,
      account: this.$store.state.account,
      insurancePersonVisible: false,
      insuranceLotVisible: false,
      options: [
        {
          value: 230000000000,
          label: '黑龙江',
          isLeaf: false

        }

      ],
      orgList: [], // 承保机构
      yearList: [], // 投保年度
      typeList: [], // 险种列表
      orderList: [{ id: 1, name: '独立投保' }, { id: 2, name: '非独立投保' }], // 保单类型
      // orderStatusList: [{ id: 0, name: '未录入保单信息' }, { id: 1, name: '已录入保单信息' }], // 保单状态
      // orderStatusList: [{ id: 1, name: '已出单' }, { id: 2, name: '已生效' }, { id: 3, name: '已失效' }, { id: 4, name: '已取消' }], // 保单状态
      orderStatusList: [{ id: 1, name: '已出单' }, { id: 2, name: '已生效' }, { id: 3, name: '已失效' }], // 保单状态
      queryParams: {},
      loading: false,
      paginationInfo: null,
      pagination: {
        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      dataSource: [
        // { id: '111', orderName: '投保单123', personName: '投保人', status: 1, applicationType: 2, personIdCard: '150422198906143546' }

      ] // 表格列表
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '保单号',
          dataIndex: 'policyNo',
          align: 'center',
          width: 140,
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: '保单名称',
          dataIndex: 'policyName',
          align: 'center',
          width: 160,
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: '保单类型',
          dataIndex: 'policyType',
          align: 'center',
          customRender: (text) => {
            if (text === 1) {
              return '独立保单'
            } else { return '非独立保单' }
          }
        }, {
          title: '承保机构',
          dataIndex: 'headCompanyName',
          align: 'center'
        }, {
          title: '投保险种',
          dataIndex: 'insuranceTypeName',
          align: 'center'
        }, {
          title: '作物标的',
          dataIndex: 'plantTypeName',
          align: 'center',
          width: 80
        }, {
          title: '保单状态',
          dataIndex: 'policyStatus',
          align: 'center',
          width: 80,
          customRender: (text) => {
            // if (text === 1) {
            //   return '已录入保单信息'
            // } else { return '未录入保单信息' }
            let txt = text.toString()

            switch (txt) {
              case '1':
                return '已出单'
                break
              case '2':
                return '已生效'
                break
              case '3':
                return '已失效'
                break
              case '4':
                return '已取消'
            }
          }
        }, {
          title: '参保县（区）',
          dataIndex: 'countyName',
          align: 'center'
        }, {
          title: '参保乡（镇）',
          dataIndex: 'countryName',
          align: 'center'
        }, {
          title: '参保村',
          dataIndex: 'villageName',
          align: 'center'
        }, {
          title: '投保人数量',
          dataIndex: 'personNum',
          align: 'center',
          width: 100
        }, {
          title: '投保地块数量',
          dataIndex: 'landNum',
          align: 'center'
        }, {
          title: '投保面积（亩）',
          dataIndex: 'cbAcreage',
          align: 'center',
          width: 120
        }, {
          title: '保费（元）',
          dataIndex: 'premium',
          align: 'center',
          customRender: (text) => {
            return text || '-'
          }
        }, {
          title: '保额（元）',
          dataIndex: 'amount',
          align: 'center',
          width: 100,
          customRender: (text) => {
            return text || '-'
          }
        }, {
          title: '操作',
          dataIndex: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          // fixed: 'right',
          width: 100
        }]
    }

  },
  created () {
    // 获取承保机构
    this.getOrgList()
    // 获取投保年度
    this.getYearList()
    // 获取险种
    this.selectInsuranceTypeList()
  },
  async mounted () {
    // 设置默认地区
    await this.setDefaultAddress()
    this.handleSearch()
  },
  methods: {
  /* 设置默认地区 */
    async setDefaultAddress () {
      let addr = this.account.userArea
      let cityList = []
      let countyList = []
      let countryList = []
      let villageList = []
      switch (this.level) {
        case 1:
          // 省
          cityList = await this.getAddress(addr.province, this.level)
          this.options[0].children = [...cityList]
          this.options[0].disabled = true
          this.$set(this.queryParams, 'address', [addr.province])
          break
        case 2:
          // 市
          cityList = await this.getAddress(addr.province, this.level)
          this.options[0].children = [...cityList].filter(i => i.value === addr.city)
          this.options[0].disabled = true
          countyList = await this.getAddress(addr.city, this.level)
          this.options[0].children[0].children = [...countyList]
          this.options[0].children[0].disabled = true
          this.$set(this.queryParams, 'address', [addr.province, addr.city])
          break
        case 3:
        // 区县
          cityList = await this.getAddress(addr.province, this.level)
          this.options[0].children = [...cityList].filter(i => i.value === addr.city)
          this.options[0].disabled = true
          countyList = await this.getAddress(addr.city, this.level)
          this.options[0].children[0].children = [...countyList].filter(i => i.value === addr.county)
          this.options[0].children[0].disabled = true
          countryList = await this.getAddress(addr.county, this.level)
          this.options[0].children[0].children[0].children = [...countryList].filter(i => i.value === addr.county)
          this.options[0].children[0].children[0].disabled = true
          this.$set(this.queryParams, 'address', [addr.province, addr.city, addr.county])
          break
        case 4:
        // 乡镇
          cityList = await this.getAddress(addr.province, this.level)
          this.options[0].children = [...cityList].filter(i => i.value === addr.city)
          this.options[0].disabled = true
          countyList = await this.getAddress(addr.city, this.level)
          this.options[0].children[0].children = [...countyList].filter(i => i.value === addr.county)
          this.options[0].children[0].disabled = true
          countryList = await this.getAddress(addr.county, this.level)
          this.options[0].children[0].children[0].children = [...countryList].filter(i => i.value === addr.county)
          this.options[0].children[0].children[0].disabled = true
          villageList = await this.getAddress(addr.country, this.level)
          this.options[0].children[0].children[0].children[0].children = [...villageList]
          this.options[0].children[0].children[0].children[0].disabled = true
          this.$set(this.queryParams, 'address', [addr.province, addr.city, addr.county, addr.country])
          break
        case 5:
          // 村
          this.$set(this.queryParams, 'address', [addr.province, addr.city, addr.county, addr.country, addr.village])
          break
        default:
          break
      }
    },
    /* 搜索 */
    handleSearch () {
      // 重置分页

      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      if (this.paginationInfo) {
        this.paginationInfo.current = this.pagination.defaultCurrent
        this.paginationInfo.pageSize = this.pagination.defaultPageSize
      }
      this.paginationInfo = null

      this.fetch({
        ...this.queryParams
      })
    },
    /* 导出 */
    handleExport () {
      let params = {...this.queryParams}
      let address = params.address || []
      if (address.length > 0) {
        params.province = address[0]
      }
      if (address.length > 1) {
        params.city = address[1]
      }
      if (address.length > 2) {
        params.county = address[2]
      }
      if (address.length > 3) {
        params.country = address[3]
      }
      if (address.length > 4) {
        params.village = address[4]
      }
      if (!params.insuranceType) { params.insuranceType = '' }
      this.$export('/insurance/policy/getPolicyManageExport', params).then(r => { })
    },
    /* 重置 */
    async handleReset () {
      // 获取险种
      this.selectInsuranceTypeList()
      // 重置地区
      this.options = [
        {
          value: 230000000000,
          label: '黑龙江',
          isLeaf: false
        }

      ]
      // 重置查询参数
      this.queryParams = {
        // provience: 230000000000
      }
      // 设置默认地区
      await this.setDefaultAddress()
      // 重置分页
      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      if (this.paginationInfo) {
        this.paginationInfo.current = this.pagination.defaultCurrent
        this.paginationInfo.pageSize = this.pagination.defaultPageSize
      }
      this.paginationInfo = null

      this.fetch({ ...this.queryParams })
    },
    /* 投保险种根据投保年度联动 */
    handleChangeYear (e) {
      // 清除已选年度
      this.$set(this.queryParams, 'insuranceType', undefined)
      this.selectInsuranceTypeList()
    },

    /*  获取险种 */
    selectInsuranceTypeList () {
      this.$get('/insurance/policy/getAddSlipInsuranceList', { year: this.queryParams.year || '' }).then(r => {
        this.typeList = r.data.rows
      })
    },
    /* 获取承保机构 */
    getOrgList () {
      this.$post('/auth/Org/findOrgList', { platformId: 2, pageNum: 1, pageSize: 1000 }, { type: 'json' }).then(r => {
        let data = r.data.data

        if (data && data.rows && data.rows.length > 0) this.orgList = data.rows.filter(i => i.provinceId === 0)
        else this.orgList = []
      })
    },
    /* 获取投保年度 */
    getYearList () {
      this.$get('/insurance/policy/getInsuranceYearList').then(r => {
        if (r.data.code === '0001') { this.yearList = r.data.data } else this.yearList = []
      })
    },
    /* 地区选择 */
    onChange (value) {
      console.log(value)
      // let address = value
      // if (address.length > 0) {
      //   this.$set(this.queryParams, 'provience', address[0])
      // }
      // if (address.length > 1) {
      //   this.$set(this.queryParams, 'city', address[1])
      // }
      // if (address.length > 2) {
      //   this.$set(this.queryParams, 'county', address[2])
      // }
      // if (address.length > 3) {
      //   this.$set(this.queryParams, 'country', address[3])
      // }
      // if (address.length > 4) {
      //   this.$set(this.queryParams, 'village', address[4])
      // }
    },
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true

      this.$get(`/system/tArea/${targetOption.value}`).then(r => {
        console.log(r)
        targetOption.loading = false
        for (let i = 0; i < r.data.row.length; i++) {
          if (r.data.row[i].level < 5) {
            r.data.row[i].isLeaf = false
          }
        }
        targetOption.children = r.data.row
        this.options = [...this.options]

        // this.$data[levelName] = r.data.row
      })

      // load options lazily
      // setTimeout(() => {
      //   targetOption.loading = false
      //   targetOption.children = [
      //     {
      //       label: `${targetOption.label} Dynamic 1`,
      //       value: 'dynamic1'
      //     },
      //     {
      //       label: `${targetOption.label} Dynamic 2`,
      //       value: 'dynamic2'
      //     }
      //   ]
      //   this.options = [...this.options]
      // }, 1000)
    },
    /* 获取地区列表 */
    async getAddress (code, level) {
      let address = await this.$get(`/system/tArea/${code}`)
      let newAddr = address.data.row.map(i => {
        if (level < 5)i.isLeaf = false

        return i
      })
      return newAddr
    },
    /* 返回 */
    handleBack () {
      this.$emit('back')
    },
    handleTableChange (pagination) {
      this.paginationInfo = pagination
      this.fetch(this.queryParams)
    },
    /* 投保人名单 */
    handleInsurancePerson (record) {
      this.insurancePersonVisible = true
      this.$refs.insurancePersonPage.rowInfo = { ...record }
    },
    /* 关闭投保人名单 */
    handleInsurancePersonClose () {
      this.insurancePersonVisible = false
    },
    /* 打开投保地块 */
    handleLotDetail (record) {
      this.insuranceLotVisible = true
      this.$refs.insuranceLotPage.rowInfo = { ...record }
      // this.insurancePersonVisible = false
    },

    /* 关闭投保地块 */
    handleInsuranceLotClose () {
      this.insuranceLotVisible = false
    },
    fetch (params = {}) {
      let address = params.address || []
      if (address.length > 0) {
        params.province = address[0]
      }
      if (address.length > 1) {
        params.city = address[1]
      }
      if (address.length > 2) {
        params.county = address[2]
      }
      if (address.length > 3) {
        params.country = address[3]
      }
      if (address.length > 4) {
        params.village = address[4]
      }
      if (!params.insuranceType) { params.insuranceType = '' }
      this.loading = true

      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get('/insurance/policy/getPolicyManageList', {
        ...params
      }).then(r => {
        this.loading = false
        let data = r.data
        const pagination = { ...this.pagination }
        pagination.total = data.total
        this.dataSource = data.rows

        this.pagination = pagination
      })
    }

  }

}
</script>
<style scoped lang="less">

.card-area {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // margin-left: 40px;
  // margin-right: 60px;
  margin:0 2rem;
  background: none;
  padding:0 1rem;
}
/deep/.ant-card-body{
padding:0;
height: 100%;
display: flex;
flex-direction: column;
}
.u_btn {
  border-radius: 4px !important;
  color: #fff !important;
  border-color: #0ca3f1 !important;

}
.u_btn1 {
  background: rgba(10, 64, 108, 1) !important;
}
.u_btn2 {
  background: rgba(8, 78, 114, 1) !important;
}
.u_btn3 {
  background: rgba(4, 70, 89, 1) !important;
}
.u_btn_radius {
  border-radius: 20px !important;
  margin-bottom: 20px;
  color: #0ca3f1 !important;
}
.opt_box {
  a {
    color: #44b6ff;
  }
}
/deep/ .ant-btn {
  padding: 0 25px;
  margin-right: 4px;
}
/deep/ .ant-form {
  // margin-bottom: 20px;
  height: 20%;
}
/deep/ .ant-form-item-label > label {
  color: #fff;
}
/deep/ .ant-select-selection,
/deep/ .ant-input {
  background: rgba(10, 64, 108, 1);
  border: 1px solid #0ca3f1;
  color: #fff;
}
/deep/ .ant-input::placeholder {
  color: #fff;
}
/deep/.ant-input,
/deep/.ant-select-selection__placeholder,
/deep/.ant-select-search__field__placeholder {
  color: #fff;
}
/deep/ .ant-select-arrow .ant-select-arrow-icon svg,
/deep/.anticon {
  color: #0ca3f1 !important;
  font-size: 1rem;
}
/* cascader */
/deep/.ant-cascader-picker {
  background: rgba(10, 64, 108, 1);
}
/deep/.ant-cascader-picker {
  color: #fff;
}
// /deep/ .ant-cascader-menus{
//   background: rgba(10, 64, 108, 1);
//   border: 1px solid #0ca3f1;
//   color: #fff;
// }
// /deep/ .ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon{
//  color: #fff;
// }
// /deep/.ant-select-dropdown {
//   border: 1px solid red !important;
//   box-shadow: none;
// }
// /deep/.ant-select-dropdown-menu-item {
// color: red;
// }
/* table */
/deep/.ant-table-thead > tr > th {
  background: none;
  color: #fff;
  // padding:10px 2px;
  background: #032f54;
  border: none;
}
/deep/.ant-table-small,
/deep/.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr {
  border: none;
}
/deep/.ant-table-small.ant-table-bordered .ant-table-content {
  border: none;
}
/deep/.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #032f54;
  padding: 10px 2px;
}
/deep/.ant-table-bordered .ant-table-body > table {
  border: none;
}
/deep/.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr {
  border: none;
}
/deep/.ant-table-fixed-left table,
.ant-table-fixed-right table {
  background: none;
}
/deep/.ant-table-placeholder,
/deep/.ant-table-bordered.ant-table-empty .ant-table-placeholder,
/deep/.ant-table-bordered .ant-table-tbody > tr > td {
  background: none;
  border: none;
  color: #fff;
}
/deep/.ant-empty-normal {
  color: #fff;
}
/deep/
  .ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr:nth-child(2n-1)
  > td {
  padding: 17px 4px;
}
/deep/ .ant-table-tbody tr:nth-child(2n) {
  background: rgba(14, 92, 157, 0.2);
}
/deep/.ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
  background: rgba(14, 92, 157, 0.4);
}

/deep/.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body{
background: none;
  &::-webkit-scrollbar {
    width:0 !important;
    height: 0 !important;
  }
}

/deep/.ant-table-small > .ant-table-content .ant-table-header{
 background: #032f54;
     overflow: hidden !important;
}

/* 分页 */
/deep/ .ant-pagination-item-active {
  background: none;
  border: 1px solid #0ca3f1;
  color: #fff;
}
/deep/.ant-pagination-item a {
  color: #fff;
}
/deep/.ant-pagination-options-quick-jumper input {
  background: rgba(10, 64, 108, 1);
  border: 1px solid #0ca3f1;
  color: #fff;
}
/deep/.ant-pagination-options-quick-jumper {
  color: #fff;
}
/deep/.anticon {
  color: #fff;
}
/deep/.ant-pagination.mini .ant-pagination-total-text{
color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/InsurancePolicy.vue